const $ = window.jQuery;

$(function () {
	
	if (document.querySelector('.sticky-theatre')) {
		// Function to setup the sticky banner on the hero lockup banner
		function handleScrollTheatre() {
			const setIsSticky = document.querySelector('.sticky-theatre');
			
			// Cancel sticky if on mobile
			const siteWidth = window.innerWidth;
			if (siteWidth <= 1024) {
				setIsSticky.classList.remove('sticky');
				return;
			}

			// Cancel sticky if element does not exist
			const stickyBarrier = document.getElementById('sticky-barrier');
			if (!stickyBarrier) return;

			// Get elements and value from top viewport
			const barrierTop = stickyBarrier.getBoundingClientRect().top;
			const viewportTop = window.scrollY;

			if (barrierTop < 0 && viewportTop >= 50) {
				setIsSticky.classList.remove('sticky');
			} else {
				setIsSticky.classList.add('sticky');
			}
		}

		// Listen to scroll and resize events
		window.addEventListener('scroll', handleScrollTheatre);
		window.addEventListener('resize', handleScrollTheatre);

		// Trigger on load
		handleScrollTheatre();
	}
});
